/**
 * 账号停用/删除的统一会话处理：记录原因、重置 Pinia 用户与权限状态、
 * 清理会话并返回登录页，避免反复登录跳转。
 */
import axios from 'axios'
import { clearAuthCookies } from '@/utils/auth'

export const ACCOUNT_DISABLED_REASON = 'ACCOUNT_DISABLED'
export const ACCOUNT_DELETED_REASON = 'ACCOUNT_DELETED'

let handlingAccountBlocked = false

export function accountReasonOf(response: { data?: unknown } | undefined | null): string | null {
  if (!response || typeof response !== 'object') return null
  const data = (response as { data?: unknown }).data
  if (!data || typeof data !== 'object') return null
  const reason = (data as Record<string, unknown>).reason
  return typeof reason === 'string' ? reason : null
}

export function isAccountBlockedReason(reason: unknown): boolean {
  return reason === ACCOUNT_DISABLED_REASON || reason === ACCOUNT_DELETED_REASON
}

export function isAccountBlockedError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false
  return isAccountBlockedReason(accountReasonOf(error.response))
}

export function accountBlockedMessage(reason: string): string {
  switch (reason) {
    case ACCOUNT_DISABLED_REASON:
      return '账号已停用，请联系管理员'
    case ACCOUNT_DELETED_REASON:
      return '账号已删除，请联系管理员'
    default:
      return '账号状态异常，请联系管理员'
  }
}

export function handleAccountBlocked(reason: string): void {
  if (handlingAccountBlocked) return
  handlingAccountBlocked = true

  console.error(accountBlockedMessage(reason))
  clearAuthCookies()
  void import('@/stores/user')
    .then(({ useUserStore }) => {
      try {
        useUserStore().reset()
      } catch {
        /* Pinia 未就绪时忽略，仅清理会话 */
      }
    })
    .catch(() => {})

  const currentPath = window.location.pathname
  if (currentPath === '/login' || currentPath === '/web/login' || window.location.href.includes('/login')) {
    return
  }
  setTimeout(() => {
    window.location.href = '/login'
  }, 1500)
}

/** 登录回调失败跳转 /login?reason=... 时记录停用（或删除）原因，并清理地址栏参数。 */
export function consumeLoginReasonFromUrl(): void {
  let params: URLSearchParams
  try {
    params = new URLSearchParams(window.location.search)
  } catch {
    return
  }
  const reason = params.get('reason')
  if (!isAccountBlockedReason(reason)) return
  console.error(accountBlockedMessage(reason as string))
  params.delete('reason')
  const query = params.toString()
  window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : ''))
}
